import { useState } from "react";
import { v4 as uuid } from "uuid";

export function useUniqueId() {
  const [id] = useState(uuid);

  return id;
}
